import { Controller } from "@hotwired/stimulus"

// Submits a form a moment after the last change, so typing "650" sends one
// request, not three. The server does the work and answers with the page or
// the Turbo Frame it expects; nothing is computed here.
//
//   <form data-controller="autosubmit" data-action="change->autosubmit#queue">
export default class extends Controller {
  static values = { delay: { type: Number, default: 300 } }

  queue() {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.submit(), this.delayValue)
  }

  submit() {
    clearTimeout(this.timer)
    this.element.requestSubmit()
  }

  disconnect() {
    clearTimeout(this.timer)
  }
}
